import { DataService } from './data.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Url } from '../common/url';
@Injectable({
  providedIn: 'root'
})
export class UserService extends DataService {

  constructor(http: HttpClient, private localHttp : HttpClient) { 
    super('user', http);
  }

  /*
  url : string = Url.user;

  getAll(){
    return this.localHttp.get(this.url + '?filter[include]=visits' );
  }
  */
  
}
